import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { CategoryList } from './category-list';
import { v2Component } from '../../../index';
import { ToastContainer } from 'react-toastify';

export function initCategoryList() {
  document.getElementsByName('category-list').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <CategoryList {...dataset} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
